"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EOSType = void 0;
var EOSType = {
  ios: 'ios',
  android: 'android',
  other: 'other'
};
exports.EOSType = EOSType;